import { z } from 'zod'
export const ForwardTaskSchema = z
	.object({
		userId: z.string().min(1),
		comment: z.string().default(''),
	})
	.strict()
